var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-upload-dragger",
    class: {
      'is-dragover': _vm.dragover
    },
    on: {
      "drop": function($event) {
        $event.preventDefault();
        _vm.onDrop($event)
      },
      "dragover": function($event) {
        $event.preventDefault();
        _vm.onDragover($event)
      },
      "dragleave": function($event) {
        $event.preventDefault();
        _vm.dragover = false
      }
    }
  }, [_vm._t("default")], 2)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6c0e13c7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c0e13c7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/QnUpload-1.0.0/upload/src/upload-dragger.vue
// module id = lzf8
// module chunks = 212